<div class="header-status" id="header-status">
    <div>{{"page.MFASettings.matStepLabel.step3.prefStatus" | translate }} 
        <span class="enabled" [class.disabled]="userMfaPreferences.Configuration?.IsUserMFAEnable === 0">
          {{userMfaPreferences.Configuration?.IsUserMFAEnable==1?'Enabled':'Disabled'}}</span>
    </div>
    <div></div>
</div>
<mat-tab-group animationDuration="0ms" class="mfasetup" id="mfasetup" [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onChangeTab($event)">
    <mat-tab>
      <ng-template mat-tab-label>
        <div>
          <i class="fa-solid fa-shield-halved"></i>
          {{ 'page.MFASettings.AppAuthLabel' | translate }}
        </div>
        <!-- <i class="fa-solid fa-circle-check" *ngIf="tabVisited"></i> -->
      </ng-template>  
        <form [formGroup]="authMethodForm" class="authMethod">
          <!-- <p class="box-title">
            {{"page.MFASettings.matStepLabel.step3.AuthenticationMethod.AuthenticationMethodLabel" | translate}}
            <span class="mandatestar">*</span>
          </p> -->
          <div class="formGroup">
            <div class="formLabel">{{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.defaultKey" |
                    translate }}<span class="mandatoryColor">*</span> 
               <a [href]="infoUrl" target="_blank" rel="noopener">
                <a [href]="infoUrl" target="_blank" rel="noopener">
                  <i class="fa-solid fa-circle-info infoIcon"></i>
                </a>
              </a>
            </div>  
            <mat-form-field floatLabel="never">
              <!-- <mat-label>{{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.defaultKey" | translate }}</mat-label> -->
              <mat-select formControlName="authType" (selectionChange)="onAuthTypeChange($event.value)">
                <mat-option [value]="0" disabled>Select an authentication type</mat-option>
                <mat-option *ngFor="let authType of mfaAuthTypes" [value]="authType.Id">
                  {{ authType.Name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="authMethodForm.get('authType')?.hasError('required')">
                {{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.defaultKey" | translate }}
              </mat-error>
            </mat-form-field>
            
          </div>
          <div class="formGroup">
            <div class="formLabel">{{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.ValidTillDays" |
                    translate }}<span class="mandatoryColor">*</span> 
               <a [href]="infoUrl" target="_blank" rel="noopener">
                <a [href]="infoUrl" target="_blank" rel="noopener">
                  <i class="fa-solid fa-circle-info infoIcon"></i>
                </a>
              </a>
            </div> <mat-form-field floatLabel="never">
              <!-- <mat-label>{{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.ValidTillDays" |
                  translate }}</mat-label> -->
              <input matInput placeholder="" type="text" formControlName="ValidTillDays" />
              <mat-error *ngIf="authMethodForm.get('ValidTillDays')?.hasError('required')">
                  {{"page.MFASettings.MFAErrors.ValidTillDaysRequiredMsg" | translate }}
              </mat-error>
              <mat-error *ngIf="authMethodForm.controls['ValidTillDays'].hasError('numeric')"
                  class="error">
                  {{"page.MFASettings.MFAErrors.ValidDaysNumericErr" | translate }}
              </mat-error>
              <mat-error *ngIf="authMethodForm.get('ValidTillDays')?.hasError('max')">
                  {{"page.MFASettings.MFAErrors.authDayserr" | translate }}
              </mat-error>
          </mat-form-field>
          <section  class="masterConfiguredCheckbox"  >
              <mat-checkbox #masterCheckbox id="masterConfiguredCheckbox" value="1"  (change)="getDefaultMFAValidTillDays($event)">
                  {{ 'page.MFASettings.matStepLabel.step3.MFAKeyAttributes.masterConfiguredMFADuration' | translate }} ({{ userMfaPreferences.Configuration?.DefaultMFAValidTillDays }} Days)
              </mat-checkbox>
          </section>
          </div>
          <!-- <p *ngIf="authTypeMsgMap[authMethodForm.get('authType')?.value]">
            {{ authTypeMsgMap[authMethodForm.get('authType')?.value] | translate }}
            <span class="clickbutton" (click)="goToStepForAuthType(authMethodForm.get('authType')?.value)">
              {{"page.MFASettings.matStepLabel.step3.AuthenticationMethod.ClickHere"|translate}}
            </span>
            {{"page.MFASettings.matStepLabel.step3.AuthenticationMethod.ToConfigure"|translate}}
          </p>  -->
          <!-- <button type="button" (click)="procedTosavePref()"
          [disabled]="!isProceedEnabled"
                  mat-raised-button color="primary" class="btn-primary">
                  {{"page.MFASettings.ProceedBtn" | translate }}
          </button> -->
          <button type="button" [disabled]="!isProceedEnabled" (click)="onTabFormSaved(true)"  *ngIf="showSaveButton"
                  mat-raised-button color="primary" class="btn-primary">
                  {{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.saveButton" | translate }}
          </button>
          <button type="button" [disabled]="!isProceedEnabled"  *ngIf="showNextButton" (click)="goToStepForAuthType(authMethodForm.get('authType')?.value)"
                  mat-raised-button color="primary" class="btn-primary">
                  {{ 'page.login.form.accessCode.proceedButton' | translate }}
          </button>
        </form>
      </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <div>
          <i class="fa-solid fa-circle-question"></i>
          {{'page.MFASettings.matStepLabel.step3.MFAKeyAttributes.defaultLabel' | translate }}
        </div>
        <i class="fa-solid fa-circle-check" *ngIf="CheckPreference?.IsQuestionsSet"></i>
      </ng-template> 
        <form [formGroup]="securityQuestionForm" class="security-question">
          <p class="box-title">{{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.SecurityQuesLabel" | translate }}
            <a [href]="infoUrl" target="_blank" rel="noopener">
              <i class="fa-solid fa-circle-info infoIcon"></i>
            </a></p>
          <div class="formGroup">
            <div class="formLabel">{{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.SecurityQues1" |
                    translate }}<span class="mandatoryColor">*</span> 
                <!-- <i class="fa-solid fa-circle-info infoIcon"></i> -->
            </div>
            <mat-form-field floatLabel="never">
              <!-- <mat-label>
                {{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.SecurityQues1" | translate}}
              </mat-label> -->
              <mat-select formControlName="question1" (selectionChange)="onQuestionChange(1)" required>
                <mat-option *ngFor="let ques of questions" [disabled]="ques.Id === question2"  [value]="ques.Id">
                  {{ques.QuestionDesc}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="securityQuestionForm.get('question1')?.hasError('required')">
                {{"page.MFASettings.MFAErrors.SecurityQues1err" | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="formGroup">
            <div class="formLabel">{{"Enter your answer" |
                    translate }}<span class="mandatoryColor">*</span> 
                <!-- <i class="fa-solid fa-circle-info infoIcon"></i> -->
            </div>
            <mat-form-field floatLabel="never">
              <input matInput placeholder="Enter your answer" type="text" formControlName="answer1" />
              <mat-error *ngIf="securityQuestionForm.get('answer1')?.hasError('required')">
                {{"page.MFASettings.MFAErrors.answerReqerr" | translate }}
              </mat-error>
              <mat-error
                                    *ngIf="securityQuestionForm.get('answer1')?.hasError('maxlength') && (securityQuestionForm.get('answer1')?.touched || securityQuestionForm.get('answer1')?.dirty)">
                                     {{"page.MFASettings.MFAErrors.answerMaxerr" | translate }}
                                </mat-error>
            </mat-form-field>
          </div>  
          <div class="formGroup">
            <div class="formLabel">{{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.SecurityQues2" |
                    translate }}<span class="mandatoryColor">*</span> 
                <!-- <i class="fa-solid fa-circle-info infoIcon"></i> -->
            </div>
            <mat-form-field floatLabel="never">
              <!-- <mat-label>
                {{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.SecurityQues2" | translate}}
              </mat-label> -->
              <mat-select formControlName="question2" (selectionChange)="onQuestionChange(2)">
                <mat-option *ngFor="let ques of questions" [disabled]="ques.Id === question1" [value]="ques.Id">
                  {{ques.QuestionDesc}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="securityQuestionForm.get('question2')?.hasError('required')">
                {{"page.MFASettings.MFAErrors.SecuirtyQues2err" | translate}}
              </mat-error>
            </mat-form-field>
          </div>    
          <div class="formGroup">
            <div class="formLabel">{{"Enter your answer" |
                    translate }}<span class="mandatoryColor">*</span> 
                <!-- <i class="fa-solid fa-circle-info infoIcon"></i> -->
            </div>
            <mat-form-field floatLabel="never">
              <input matInput placeholder="Enter your answer" type="text" formControlName="answer2" />
              <mat-error *ngIf="securityQuestionForm.get('answer2')?.hasError('required')">
                {{"page.MFASettings.MFAErrors.answerReqerr" | translate }}
              </mat-error>
              <mat-error *ngIf="securityQuestionForm.get('answer2')?.hasError('maxlength') && (securityQuestionForm.get('answer2')?.touched || securityQuestionForm.get('answer2')?.dirty)">
                {{"page.MFASettings.MFAErrors.answerMaxerr" | translate }}
              </mat-error>
            </mat-form-field>
          </div>    
            
          <div>  <button type="button" (click)="onTabFormSaved()"
            [disabled]="!securityQuestionForm.valid"
            mat-raised-button color="primary" class="btn-primary">
            {{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.saveButton" | translate }}
    </button></div>
        </form>
      </mat-tab>
  
      <mat-tab *ngIf="authMethodForm.get('authType')?.value === 4">
        <ng-template mat-tab-label>
          <div>
            <i class="fa-solid fa-mobile"></i>
            {{ 'page.MFASettings.AuthAppTab' | translate }}
          </div>
          <i class="fa-solid fa-circle-check" *ngIf="CheckPreference?.IsAuthenticatorAppConfigured"></i>
        </ng-template> 
        <div class="qrcode">
            <p><strong>{{ 'page.MFASettings.MobileAppTotpLabel' | translate }}</strong></p>
            <p>{{ 'page.MFASettings.MobileAppTotpStep1' | translate }}</p>
            <p>{{ 'page.MFASettings.MobileAppTotpStep2' | translate }}</p>
          
                <form [formGroup]="downloadAppStep" id="downloadAppSection">
                    <mat-tab-group animationDuration="0ms" mat-align-tabs="center" class="qrsetup" id="qrsetup">
                        <mat-tab label="{{ 'page.MFASettings.matStepLabel.step2.Qrcode' | translate }}"
                            id="scanBarcodeTabBtn">
                            <div class="qrcodescaner">
                                <div class="codeScanBox" id="codeScannerBox">
                                  <ng-container *ngIf="appQRdata">
                                    <img class="scannerImg" [src]="appQRdata.QrCodeUrl" id="verifyScanCode" />
                                  </ng-container>                                
                                </div>
                                <div class="otp-box">
                                    <input *ngFor="let digit of otpArray; let i = index" type="text" maxlength="1"
                                        class="otp-input" [(ngModel)]="otpValues[i]"  (paste)="handlePaste($event)"
                                        [ngModelOptions]="{standalone: true}" (input)="onInput($event, i)"
                                        (keydown.backspace)="onBackspace($event, i)" #otpInput />
                                </div> 
                                <div class="otp-error" *ngIf="invalidOtp"
                                    style="color: #f44336; font-size: 12px; margin-top: 4px;">
                                    {{"page.MFASettings.MFAErrors.OTPErr" | translate }}
                                </div>
                            </div>
                        </mat-tab>
                        <mat-tab label="{{ 'page.MFASettings.matStepLabel.step2.enterCode' | translate }}"
                            id="enterKeyTabBtn">
                            <div class="enterKeyBox" id="enterKeyDetailBox">
                                <mat-form-field>
                                    <mat-label>{{
                                        "page.MFASettings.matStepLabel.step2.KeyInputOption.AccountLabel"
                                        | translate }}</mat-label>
                                    <input matInput type="email" formControlName="accountInputCtrl"
                                        id="accountInput" readonly>
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>{{
                                        "page.MFASettings.matStepLabel.step2.KeyInputOption.keyLabel"
                                        | translate }}</mat-label>
                                    <input matInput formControlName="keyInputCtrl" id="keyInput"
                                        readonly>
                                </mat-form-field>
                            </div>
                        </mat-tab>
                    </mat-tab-group>

                    <div>  <button type="button" (click)="verifyOtp()"
                        [disabled]="!downloadAppStep.valid || !isOtpValid()"
                        mat-raised-button color="primary" class="btn-primary">
                        {{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.saveButton" | translate }}
                </button></div>
                </form>
        
        </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <div>
          <i class="fa-solid fa-address-card"></i>
          {{ 'page.MFASettings.MatTabContact' | translate }}
        </div>
        <i class="fa-solid fa-circle-check" *ngIf="CheckPreference?.IsEmailSet || CheckPreference?.IsPhoneNumberSet"></i>
      </ng-template> 
        <form [formGroup]="contactDetailsForm" class="phonegroup" id="phonegroup">
          <p class="box-title"> {{ 'page.MFASettings.MatTabContact' | translate }}<a [href]="infoUrl" target="_blank" rel="noopener">
            <i class="fa-solid fa-circle-info infoIcon"></i>
          </a></p>
          <div class="formGroup">
            <div class="formLabel">{{"Email Address" |
                    translate }}<span class="mandatoryColor">*</span> 
                <!-- <i class="fa-solid fa-circle-info infoIcon"></i> -->
            </div>
            <mat-form-field floatLabel="never">
              <input matInput placeholder="Email Address" type="text" formControlName="email" />
              <mat-error *ngIf="contactDetailsForm.get('email')?.hasError('required')">
                  {{"page.MFASettings.MFAErrors.EmailReqErr" | translate }}  
                </mat-error>
                <mat-error *ngIf="contactDetailsForm.get('email')?.hasError('email')">
                  {{"page.MFASettings.MFAErrors.EmailValidErr" | translate }}    
                </mat-error>
                <mat-error *ngIf="contactDetailsForm.get('email')?.hasError('maxlength')">
                  {{"page.MFASettings.MFAErrors.EmailMaxErr" | translate }}    
              </mat-error>
            </mat-form-field>
          </div>  
          
          <div class="formGroup">
            <div class="formLabel">{{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.mobileKey" |
                    translate }}<span class="mandatoryColor">*</span> 
                <!-- <i class="fa-solid fa-circle-info infoIcon"></i> -->
            </div>
            <div class="two-fields">
              <mat-form-field>
                <mat-select formControlName="countryId">
                  <mat-option *ngFor="let country of countries" [value]="country?.Id">
                    {{country?.Name}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="contactDetailsForm.get('countryId')?.hasError('required')">
                    {{"page.MFASettings.MFAErrors.countryCodeErr" | translate }} 
                  </mat-error>
              </mat-form-field>
              <mat-form-field>
                <input matInput
                       placeholder=""
                       type="text"
                       formControlName="phone" />
                       <mat-error *ngIf="contactDetailsForm.get('phone')?.hasError('required') && (contactDetailsForm.get('phone')?.touched || contactDetailsForm.get('phone')?.dirty)">
                        {{"page.MFASettings.MFAErrors.phoneReqerr" | translate }}
                      </mat-error>
                      <mat-error *ngIf="contactDetailsForm.get('phone')?.hasError('maxlength') && (contactDetailsForm.get('phone')?.touched || contactDetailsForm.get('phone')?.dirty)">
                        {{"page.MFASettings.MFAErrors.phoneMaxerr" | translate }}
                      </mat-error>
                      <mat-error *ngIf="contactDetailsForm.get('phone')?.hasError('pattern') && (contactDetailsForm.get('phone')?.touched || contactDetailsForm.get('phone')?.dirty)">
                        {{"page.MFASettings.MFAErrors.phoneNumericErr" | translate }}
                    </mat-error>
              </mat-form-field>
            </div>
          </div>  
          <!-- <div style="display: flex;flex-direction: column; gap: 0px; width: 100%;">
            <mat-label class="customlabel">
              {{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.mobileKey" | translate }}
            </mat-label>
            
          </div> -->
          <div class="phonegroup-action">  <button type="button" 
            [disabled]="!contactDetailsForm.valid" (click)="onTabFormSaved()"
            mat-raised-button color="primary" class="btn-primary">
            {{"page.MFASettings.matStepLabel.step3.MFAKeyAttributes.saveButton" | translate }}
    </button></div>
        </form>
      </mat-tab>

  </mat-tab-group>